import ENGLISH_LOCALES from '@/../locales/en.json'

export const jsonEnglishLocalesContent = ENGLISH_LOCALES as Record<string, string>
